// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_FENIX = [{
  id: 'fenix_ice',
  factionId: FACTIONS.FENIX,
  name: 'Ледяная ярость',
  priceNumens: 14000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.INDIGO,
  ]
}, {
  id: 'fenix_spirit',
  factionId: FACTIONS.FENIX,
  name: 'Восставший дух',
  priceNumens: 29000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.CELADON
  ]
}, {
  id: 'fenix_dark',
  factionId: FACTIONS.FENIX,
  name: 'Чёрная ярость',
  priceNumens: 65000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.RED
  ]
}, {
  id: 'fenix_star',
  factionId: FACTIONS.FENIX,
  name: 'Карающая комета',
  priceNumens: 85000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.SKY_BLUE
  ]
}, {
  id: 'fenix_gold_legacy',
  factionId: FACTIONS.FENIX,
  name: 'Вестник рассвета',
  priceNumens: 130000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'fenix_ruby_legacy',
  factionId: FACTIONS.FENIX,
  name: 'Рождённый из пепла',
  priceCrystals: 250,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
